/**
 * Component that displays a thumbs up/down count
 *
 * @module components
 */

import PropTypes from 'prop-types';
import React from 'react';

import { THUMB_LOCATIONS, THUMB_STYLES, THUMB_TYPES } from '../../../constants/Thumbs';
import { jeCSS } from '../../../lib/StyleUtils';
import DisplayThumb from '../DisplayThumb/DisplayThumb';

import './DisplayThumbs.scss';

export default class extends React.Component {
  /**
   * @property {string} selectedThumbType - Fills in selected thumb type up/down
   * @property {func} clickHandler - called when thumb clicked with argument of THUMB_TYPES.UP/DOWN
   * @property {object} thumbsCount - thumbs up/down count to display. If not provided, no count shown
   * @property {string} styleType - BEModifiers that will be attached to each DisplayThumb
   *    important ones are 'light'/'dark' to theme for a light or dark bg respectively
   */
  static propTypes = {
    selectedThumbType: PropTypes.string,
    clickHandler: PropTypes.func,
    thumbsUp: PropTypes.number,
    thumbsDown: PropTypes.number,
    styleNames: PropTypes.arrayOf(PropTypes.oneOf([THUMB_LOCATIONS.BACKSTAGE])),
    styleType: PropTypes.oneOf([THUMB_STYLES.LIGHT, THUMB_STYLES.DARK, THUMB_STYLES.SWITCH]),
    disabled: PropTypes.bool,
  };

  onUpClick = () => {
    if (!this.props.clickHandler) {
      return;
    }

    this.props.clickHandler(THUMB_TYPES.UP);
  };

  onDownClick = () => {
    if (!this.props.clickHandler) {
      return;
    }
    this.props.clickHandler(THUMB_TYPES.DOWN);
  };

  render() {
    const selectedThumbType =
      THUMB_TYPES[this.props.selectedThumbType] || this.props.selectedThumbType || null;

    return (
      <div className={jeCSS('DisplayThumbsWrap', this.props.styleNames)}>
        <DisplayThumb
          styleName={this.props.styleType}
          thumbType={THUMB_TYPES.UP}
          count={this.props.thumbsUp}
          filled={selectedThumbType === THUMB_TYPES.UP}
          onClick={this.onUpClick}
          disabled={this.props.disabled}
        />
        <DisplayThumb
          styleName={this.props.styleType}
          thumbType={THUMB_TYPES.DOWN}
          count={this.props.thumbsDown}
          filled={selectedThumbType === THUMB_TYPES.DOWN}
          onClick={this.onDownClick}
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}
